import 'twin.macro'

import TickCheck from 'assets/icons/tick-check.svg?component'
import FreedomBoxPng from 'assets/images/freedom-box.png'
import { useTranslation } from 'react-i18next'

const FreedomBox = () => {
  const { t } = useTranslation()

  const texts = t('freedom-box.texts', { returnObjects: true }) as Array<string>

  return (
    <div tw='p-5 text-white rounded-[1.25rem] bg-freedom-box relative lg:p-8'>
      <h2 tw='text-[22px] leading-[30px] font-bold lg:text-[28px] lg:leading-[34px] lg:font-semibold'>
        {t('freedom-box.title')}
      </h2>
      <p tw='mt-1 text-[18px] leading-6 lg:text-base lg:leading-[28px] lg:max-w-[280px]'>{t('freedom-box.subtitle')}</p>
      <ul tw='mt-5 space-y-3 lg:max-w-[320px] lg:space-y-1'>
        {texts.map((text, idx) => (
          <ul key={idx} tw='flex items-center gap-x-3'>
            <TickCheck tw='flex-shrink-0' />
            <span tw='text-base leading-[22px] lg:leading-[26px]'>{text}</span>
          </ul>
        ))}
      </ul>
      <img
        src={FreedomBoxPng}
        tw='pl-7 mx-auto mt-8 w-[311px] h-[178px] lg:m-0 lg:p-0 lg:w-[210px] lg:h-[146px] lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:-right-6'
        alt='Freedom Box'
      />
      <a
        href='https://overdraft.bankffin.kz/?manager=TW_Credit&utm_source=crossell&utm_medium=banner'
        target='_blank'
        rel='noreferrer'
        tw='mt-8 py-[14px] block text-center text-base leading-5 text-[#2A8640] font-medium w-full rounded-xl bg-[#FFFFFF] lg:mt-6 lg:w-[146px]'
      >
        {t('freedom-box.btn-text')}
      </a>
    </div>
  )
}

export default FreedomBox
